import {
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import mainStyles from "../WorkerManagementComponent/WorkerManagementComponent.module.css";
import styles from "../AgentsComponent/styles.module.css";
import { Add, DeleteForever } from "@material-ui/icons";
import CreateIcon from "@material-ui/icons/Create";
import PersonIcon from "@material-ui/icons/Person";
import { useEffect, useState } from "react";
import { TeamsActions } from "../../actions/TeamsActions";
import { IExternalAgent } from "./IExternalAgent";
import { ExternalAgentsActions } from "../../actions/ExternalAgentsActions";
import { BlueInverseBtn } from "../Styled/StyledButtons";
const ExternalAgents = () => {
  const [teams, setTeams] = useState<Array<{ Id: number; Name: string }>>([]);
  const [backdrop, setBackdrop] = useState(false);
  const [agents, setAgents] = useState<IExternalAgent[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      setBackdrop(true);
      await TeamsActions.getTeams().then((teams) => {
        setTeams(teams);
      });

      await ExternalAgentsActions.get().then((agents) => {
        setAgents(agents);
      });
    };

    fetchData();
    setBackdrop(false);
  }, []);

  const toggleHandler = async (id: number) => {
    await ExternalAgentsActions.toggle(id).then(async (resp) => {
      setBackdrop(true);
      await ExternalAgentsActions.get().then((agents) => {
        setAgents(agents);
        setBackdrop(false);
      });
    });
  };

  return (
    <Container maxWidth="lg">
      <Grid container spacing={1}>
        <Grid item xs={12} className={mainStyles.WorkerSkillsBack}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div className={mainStyles.Header}>
                External Agents Management
              </div>
              <div className={mainStyles.AgentName}> &nbsp;</div>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} md={3}>
              <BlueInverseBtn
                href="/external-agent-create"
                variant="contained"
                fullWidth={true}
              >
                <Add /> Add Agent
              </BlueInverseBtn>
            </Grid>
          </Grid>
        </Grid>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  align="right"
                  className={styles.AgentIcon}
                ></TableCell>
                <TableCell align="left">Name</TableCell>
                <TableCell align="center">Team</TableCell>
                <TableCell align="center">Active</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={mainStyles.FlexColScroll}>
              {agents.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell align="right" className={styles.AgentIcon}>
                    <PersonIcon />
                  </TableCell>
                  <TableCell align="left">
                    <b>{row.name}</b>
                    <br />
                    {row.phone
                      ? (row.phone as unknown as { phone: string }).phone
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {row.team_id ? row.team_id : ""}
                  </TableCell>
                  <TableCell align="center">
                    <div className={styles.SwitchContainer}>
                      <div className={styles.Switch}>
                        <input
                          type="radio"
                          id={"switch_left_" + row.id}
                          name={"switch" + row.id}
                          value="0"
                          checked={!row.available}
                          onChange={() => toggleHandler(row.id!)}
                        />
                        <label htmlFor={"switch_left_" + row.id}>
                          Disabled
                        </label>
                        <input
                          type="radio"
                          id={"switch_right_" + row.id}
                          name={"switch" + row.id}
                          value="1"
                          checked={row.available}
                          onChange={() => toggleHandler(row.id!)}
                        />
                        <label htmlFor={"switch_right_" + row.id}>
                          Enabled
                        </label>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="right">
                    <Button
                      color="default"
                      href={"/external-agent/id/" + row.id}
                    >
                      <CreateIcon />
                    </Button>

                    <Button
                      color="secondary"
                      onClick={() => {
                        /*this.handleDelete(row.id)*/
                      }}
                    >
                      <DeleteForever />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Backdrop className={styles.Backdrop} open={backdrop}>
        <CircularProgress className={styles.BackdropProgress} />
        &nbsp;&nbsp;
        <p className={styles.BackdropProgress}>Loading...</p>
      </Backdrop>
    </Container>
  );
};

export default ExternalAgents;
